function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3 6a1 1 0 011-1h5.586a1 1 0 01.707.293L12 7h8a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V6z",
  fill: "currentColor"
});

function SvgFolder(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMgNkMzIDUuNDQ3NzIgMy40NDc3MiA1IDQgNUg5LjU4NTc5QzkuODUxIDUgMTAuMTA1NCA1LjEwNTM2IDEwLjI5MjkgNS4yOTI4OUwxMiA3SDIwQzIwLjU1MjMgNyAyMSA3LjQ0NzcyIDIxIDhWMThDMjEgMTguNTUyMyAyMC41NTIzIDE5IDIwIDE5SDRDMy40NDc3MiAxOSAzIDE4LjU1MjMgMyAxOFY2WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };